import { Mail, Phone, MapPin, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a2e] text-white" data-testid="footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 md:py-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_ec0e6c28-2dec-4a8b-9e46-60d9bf9b919f/artifacts/brhzx1m4_Logo%20no%20background.png"
                alt="Speak&Move Global Institute"
                className="w-[130px] h-auto object-contain brightness-0 invert"
                style={{ marginTop: '-30px', marginBottom: '-30px' }}
              />
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-3">
              Votre partenaire de confiance pour réussir votre projet d'études ou de travail en Allemagne.
            </p>
            <p className="text-white/50 text-xs leading-relaxed mb-5">
              SIRET : 10288785800011<br />
              Immatriculation au RCS, numéro 102 887 858 R.C.S. Paris
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/speak_move/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/speak-move-global-institute"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://wa.me/33761432040?text=Bonjour%20Speak%26Move%2C%20je%20suis%20int%C3%A9ress%C3%A9%20par%20vos%20services."
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-green-500/20 hover:bg-green-500/30 flex items-center justify-center transition-colors"
                data-testid="social-whatsapp"
              >
                <Phone className="w-5 h-5 text-green-400" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li><a href="#services" className="text-white/70 hover:text-white text-sm transition-colors">Nos services</a></li>
              <li><a href="#parcours" className="text-white/70 hover:text-white text-sm transition-colors">Comment ça marche</a></li>
              <li><a href="#temoignages" className="text-white/70 hover:text-white text-sm transition-colors">Témoignages</a></li>
              <li><a href="#faq" className="text-white/70 hover:text-white text-sm transition-colors">FAQ</a></li>
              <li><a href="/login" className="text-white/70 hover:text-white text-sm transition-colors">Espace étudiant</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Nos services</h4>
            <ul className="space-y-3">
              <li className="text-white/70 text-sm">Cours d'allemand A1-C1</li>
              <li className="text-white/70 text-sm">Préparation Goethe/TELC/ECL</li>
              <li className="text-white/70 text-sm">Montage dossier visa</li>
              <li className="text-white/70 text-sm">Accompagnement complet</li>
              <li className="text-white/70 text-sm">Suivi post-arrivée</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:contact@speak-move.com" className="flex items-center gap-3 text-white/70 hover:text-white text-sm transition-colors">
                  <Mail className="w-4 h-4 shrink-0" />
                  contact@speak-move.com
                </a>
              </li>
              <li>
                <span className="flex items-start gap-3 text-white/70 text-sm">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>
                    +237 673 85 22 37<br />
                    +33 (0)7 61 43 20 40
                  </span>
                </span>
              </li>
              <li>
                <span className="flex items-start gap-3 text-white/70 text-sm">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>
                    54 rue Monceau<br />
                    75008 Paris, France
                  </span>
                </span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Speak&Move Global Institute. Tous droits réservés.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              <a href="#mentions-legales" className="text-white/60 hover:text-white text-sm transition-colors">Mentions légales</a>
              <a href="#confidentialite" className="text-white/60 hover:text-white text-sm transition-colors">Politique de confidentialité</a>
              <a href="#cgv" className="text-white/60 hover:text-white text-sm transition-colors">CGV</a>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-white/5">
            <p className="text-white/40 text-xs text-center leading-relaxed">
              Speak&Move Global Institute — SIRET : 10288785800011 — RCS Paris n° 102 887 858<br />
              Siège social : 54 rue Monceau, 75008 Paris, France.<br />
              Partenaire agréé du Goethe-Institut, TELC et ECL pour les examens de certification en langue allemande.
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
